(function() {
  'use strict';

  function initAvailabilityHover() {
    if (!document.body || !document.body.classList.contains('template-suffix-filtration-system-other')) {
      return;
    }

    var icons = document.querySelectorAll('.template-suffix-filtration-system-other .availability-message');
    if (!icons.length) return;

    icons.forEach(function(icon) {
      if (icon.dataset.ffHoverBound === 'true') return;
      icon.dataset.ffHoverBound = 'true';

      icon.addEventListener('mouseenter', function() {
        var delivery = getDeliveryElement(icon);
        if (delivery) delivery.style.display = 'block';
      });

      icon.addEventListener('mouseleave', function() {
        var delivery = getDeliveryElement(icon);
        if (delivery) delivery.style.display = 'none';
      });
    });
  }

  function getDeliveryElement(icon) {
    var cardSection = icon.closest('.template-suffix-filtration-system-other .card__section');
    if (!cardSection) return null;
    return cardSection.querySelector('.delivery-information');
  }

  function initPriceClassifier() {
    function removeClassificationClasses(priceList) {
      var elements = priceList.querySelectorAll('[class*="classified-"]');
      elements.forEach(function(element) {
        Array.from(element.classList).forEach(function(className) {
          if (className.indexOf('classified-') === 0) {
            element.classList.remove(className);
          }
        });
      });
    }

    function hasLineThrough(element) {
      var style = element.getAttribute('style') || '';
      return element.style.textDecoration === 'line-through' || style.indexOf('line-through') !== -1;
    }

    function classifyPrices(priceList) {
      removeClassificationClasses(priceList);

      var subscriptionPrices = priceList.querySelectorAll('.appstle_subscription_final_price');
      subscriptionPrices.forEach(function(price, index) {
        price.classList.add('classified-subscription-price');
        price.classList.add('classified-subscription-price-' + (index + 1));
      });

      var highlightedPrices = priceList.querySelectorAll('.price--highlight');
      var subscriptionOriginalIndex = 0;
      var oneTimePriceIndex = 0;

      highlightedPrices.forEach(function(price) {
        var isSubscriptionPrice = price.classList.contains('appstle_subscription_final_price');
        var crossedOut = hasLineThrough(price);

        if (!isSubscriptionPrice && crossedOut) {
          subscriptionOriginalIndex += 1;
          price.classList.add('classified-subscription-original-crossed');
          price.classList.add('classified-subscription-original-crossed-' + subscriptionOriginalIndex);
        } else if (!isSubscriptionPrice && !crossedOut) {
          oneTimePriceIndex += 1;
          price.classList.add('classified-onetime-price');
          price.classList.add('classified-onetime-price-' + oneTimePriceIndex);
        }
      });

      var comparePrices = priceList.querySelectorAll('.price--compare');
      var subscriptionCompareIndex = 0;
      var oneTimeCompareIndex = 0;

      comparePrices.forEach(function(price) {
        if (hasLineThrough(price)) {
          subscriptionCompareIndex += 1;
          price.classList.add('classified-subscription-compare-crossed');
          price.classList.add('classified-subscription-compare-crossed-' + subscriptionCompareIndex);
        } else {
          oneTimeCompareIndex += 1;
          price.classList.add('classified-onetime-compare');
          price.classList.add('classified-onetime-compare-' + oneTimeCompareIndex);
        }
      });

      var saveBadges = priceList.querySelectorAll('.appstle_subscription_save, .appstle_subscription_element');
      saveBadges.forEach(function(badge, index) {
        badge.classList.add('classified-save-badge');
        badge.classList.add('classified-save-badge-' + (index + 1));
      });
    }

    var runTimer;
    function scheduleClassification(delay) {
      clearTimeout(runTimer);
      runTimer = setTimeout(function() {
        document.querySelectorAll('.product-form__info-content .price-list').forEach(classifyPrices);
      }, typeof delay === 'number' ? delay : 120);
    }

    function observePriceContainers() {
      var containers = document.querySelectorAll('.product-form__info-content');
      if (!containers.length) return;

      var observer = new MutationObserver(function(mutations) {
        var shouldRun = mutations.some(function(mutation) {
          if (mutation.type === 'attributes') {
            return mutation.target.classList && mutation.target.classList.contains('price');
          }
          return mutation.type === 'childList';
        });

        if (shouldRun) scheduleClassification(80);
      });

      containers.forEach(function(container) {
        observer.observe(container, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      });
    }

    function attachListeners() {
      scheduleClassification(300);
      document.addEventListener('change', function(event) {
        if (event.target.matches('input[name="selling_plan"]')) {
          scheduleClassification(120);
        }
      });
      document.addEventListener('click', function(event) {
        if (
          event.target.matches('input[name="selling_plan"]') ||
          event.target.closest('label[for^="appstle_selling_plan_label"]') ||
          event.target.closest('.appstle_subscription_wrapper_option')
        ) {
          scheduleClassification(120);
        }
      });
      observePriceContainers();
    }

    attachListeners();
  }

  function init() {
    initAvailabilityHover();
    initPriceClassifier();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
